import { Row, Table } from "react-bootstrap";
import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { ContentCopyOutlined } from "@mui/icons-material";
import { MedicationRegime, MedicationRegimeGroup } from "../../types/patient";
import { LinkOffOutlined } from "@mui/icons-material";

type MedicationDisplayProps = {
  regimeGroup: MedicationRegimeGroup;
  copyItem: (item: MedicationRegimeGroup) => void
};

const MedicationRegimeGroupDisplay = (props: MedicationDisplayProps) => {

  const handleCopyClicked = () => {
    props.copyItem(props.regimeGroup);
  };

  return (
    <Row className="mt-3 ms-3 me-3">
      <Table bordered>
        <thead>
          <tr>
            <th colSpan={2}></th>
            <th>Morning</th>
            <th>Breakfast</th>
            <th>Lunch</th>
            <th>Dinner</th>
            <th>Bedtime</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
        {
          props.regimeGroup.regimes.map((element: MedicationRegime, i: number) => {
            return (
              <tr>
                {i===0 ? <td rowSpan={props.regimeGroup.regimes.length} className="small-col centre">{props.regimeGroup.recordedOn}</td> : <></>} 
                <td className="small-col left">{element.name}</td>
                <td>{element.morning}</td>
                <td>{element.breakfast}</td>
                <td>{element.lunch}</td>
                <td>{element.dinner}</td>
                <td>{element.bedtime}</td>
                {i===0 ? <td rowSpan={props.regimeGroup.regimes.length} className="small-col centre">
                  {props.regimeGroup.enteredInErrorStatus ? (
                    <LinkOffOutlined color="warning" />
                  ): (
                  <Tooltip title="Copy">
                    <IconButton onClick={(e) => handleCopyClicked()}>
                      <ContentCopyOutlined sx={{color:"#78909C"}} />
                    </IconButton>
                  </Tooltip>
                  )}
                  </td> : <></>} 
              </tr>
            )
          })
        }
        </tbody>
      </Table>
      {/* <Button id="btn-copy" type="button" className='fs-6 btn-color' onClick={handleCopyClicked} >{COPY}</Button> */}
    </Row>
  ); 
}
export default MedicationRegimeGroupDisplay;